"use strict";module.exports=Number.isNaN||function(a){return a!=a};